export default __webpack_public_path__ + "media/bootstrap-icons.39795c0b.woff";